<template>
  <div style="overflow: hidden">
    <el-menu
      :default-active="$router.currentRoute.path"
      class="el-menu-vertical-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="/">
        <i class="el-icon-s-home"></i>
        <span>首页</span>
      </el-menu-item>
      <el-submenu index="/u">
        <template slot="title"><i class="el-icon-menu"></i>管理工具</template>
        <!-- <el-menu-item>
          <i class="fa fa-cog"></i>
          <a href="http://jenkins.hidaobao.com"><span>JENKINS</span></a>
        </el-menu-item> -->
        <el-menu-item>
          <i class="fa fa-gitlab"></i>
          <a href="http://git.hidaobao.com">GITLAB</a>
        </el-menu-item>
        <el-menu-item>
          <i class="fa fa-github"></i>
          <a href="http://github.com/tice9982">GITHUB</a>
        </el-menu-item>
        <!--
          <el-submenu index="2-4">
          <template slot="title">选项4</template>
          <el-menu-item index="2-4-1">选项1</el-menu-item>
          <el-menu-item index="2-4-2">选项2</el-menu-item>
          <el-menu-item index="2-4-3">选项3</el-menu-item>
        </el-submenu>
       -->
      </el-submenu>
      <el-menu-item index="/wiki">
        <i class="fa fa-wikipedia-w"></i>
        <span>wiki</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'venusmenu',
  mounted () {
    console.log(this.$root.$router.path)
  },
  methods: {
    handleSelect: function (key, keyPath) {
      console.log(key)
      this.$router.push({
        path: key,
        params: { data: 'query' }
      })
    }
  }
}
</script>

<style>
.venus-menu {
  height: 38px;
  width: calc(100% - 40px);
  margin-top: 20px;
  margin-bottom: 0px;

  position: relative;
  float: left;
  font-family: "Open Sans", sans-serif;
  list-style: none;
  background: #fff;
  box-shadow: 0 1px 3px #dedede;
  z-index: 100;
}

.venus-menu ul,
.venus-menu ul li {
  list-style: none;
  display: none;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: white;
}

.venus-menu li {
  white-space: nowrap;
  min-width: 120px;
  line-height: 20px;
  background: white;
}

.venus-menu li a {
  float: left;
  text-align: center;
  font-size: 18px;
  color: #777;
  text-decoration: none;
  margin-right: 10px;
  padding: 10px 5px;

  -webkit-transition: color 0.2s linear, background 0.2s linear;
  -moz-transition: color 0.2s linear, background 0.2s linear;
  -o-transition: color 0.2s linear, background 0.2s linear;
  transition: color 0.2s linear, background 0.2s linear;

  background: #fff;
}

.venus-menu li .indicator {
  float: right;
  width: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/venus_menu.vue